export default __webpack_public_path__ + "static/media/nutrition.90d02e87.svg";